module.exports = __webpack_public_path__ + "static/media/ic-map.d52ae070.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-map.svg
// module id = 640
// module chunks = 14